//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  head() {
    return this.$metadata(this.story)
  },
  computed: {
    ...mapState([ 'defaultMenu' ])
  },
  async validate({ store, params }) {
    let found = false
    let menu = store.state.defaultMenu
    menu.categories.map(c => {
      c.products.map(p => {
        if(p.sku.toString() == params.sku) {
          found = true
        }
      })
    })

    return found
  },
  async asyncData({ $storyblok, store, params }) {
    let story = await $storyblok.getStory('menu/_product')
    let menu = store.state.defaultMenu
    menu.categories.map(c => {
      c.products.map(p => {
        if(p.sku.toString() == params.sku) {
          store.commit('product/setData', p)
        }
      })
    })
    return {
      story,
      menu
    }
  },
  async mounted() {
    // if(this.story.content.require_location && !this.location) {
    //   this.$store.commit('setRedirect', `/${this.$route.params.slug}`)
    //   this.$router.push(this.options.locationsPage)
    // } else if(this.story.content.require_order && !this.order) {
    //   this.$store.commit('setRedirect', `/${this.$route.params.slug}`)
    //   this.$router.push(this.options.orderPage)
    // } else if(this.story.content.require_signin && !this.user) {
    //   this.$store.commit('setRedirect', `/${this.$route.params.slug}`)
    //   this.$router.push(this.options.signinPage)
    // } else if(this.story.content.require_signout && this.user) {
    //   this.$store.commit('setRedirect', `/${this.$route.params.slug}`)
    //   this.$router.push(this.options.accountPage)
    // } else {
    //   this.$storybridge(() => {
    //     const storyblokInstance = new StoryblokBridge()
    //     storyblokInstance.on(['input', 'published', 'change'], (event) => {
    //       if(event.action === 'input') {
    //         if(event.story.id === this.story.id) {
    //           this.story.content = event.story.content
    //         }
    //       } else {
    //         window.location.reload()
    //       }
    //     })
    //   })
    // }
    // if(this.story.content.product_page) {
      // let id = this.$route.params.sku
      // let defaults = []
      // let quantities = []
      // if(this.$route.query.cid) {
      //   this.menu.categories.map(c => {
      //     c.products.map(p => {
      //       if(p.id == id) {
      //         id = p.sku
      //       }
      //     })
      //   })
        // this.order.products.map(p => {
        //   if(this.$route.query.cid == p.id) {
        //     p.choices.map(c => {
        //       defaults.push(c.option_id)
        //       quantities.push(c.quantity)
        //     })
        //   }
        // })
      // }
      
      // this.$store.dispatch('product/getProduct', {
      //   id,
      //   defaults,
      //   quantities
      // })
    // } else {
    //   this.$store.dispatch('product/clearProduct')
    // }
  }
}
